module.exports = __webpack_public_path__ + "img/img_bed_app_1_ko.e0df200a.png";